import { createContext, useContext } from 'react'

export type Project = {
  /** JDE project number, e.g. "1142" — the Project table's natural key. */
  id: string
  name: string
}

export type ProjectLoadStatus = 'loading' | 'loaded' | 'error'

export type ProjectContextValue = {
  projects: Project[]
  /** Null until the list loads, when loading fails, or when no projects exist. */
  currentProject: Project | null
  status: ProjectLoadStatus
  setProject: (id: string) => void
}

export const ProjectContext = createContext<ProjectContextValue | null>(null)

/** Current project scope — every data query keys off this. */
export function useProject(): ProjectContextValue {
  const context = useContext(ProjectContext)
  if (!context) {
    throw new Error('useProject must be used within a ProjectProvider')
  }
  return context
}
